import { cB as e, c as i } from "./highrise314.mjs";
const l = e("base-icon", `
 height: 1em;
 width: 1em;
 line-height: 1em;
 text-align: center;
 display: inline-block;
 position: relative;
 fill: currentColor;
`, [i("svg", `
 height: 1em;
 width: 1em;
 `)]);
export {
  l as default
};
